import * as oneview from './oneview';
import * as infosync from './infosync';

/**
 * Canonical product theme. New UI work should target this module only.
 */
export const CANONICAL_THEME_ID = 'oneview';

/**
 * Theme modules keyed by JWT `user.theme` / API theme string (MHQ Client.theme).
 *
 * @type {Record<string, typeof oneview>}
 */
export const themeModules = {
  /** Alias for canonical theme (legacy `themes.default` usage). */
  default: oneview,
  oneview,
  infosync,
};

/**
 * Themes kept for backward compatibility. Migrate MHQ `Client.theme` and users to
 * `oneview` when ready, then remove the `infosync` folder and this list.
 * Primary/secondary hues differ slightly between oneview and infosync (see theme-migration.md).
 */
export const DEPRECATED_THEME_IDS = ['infosync'];
